import { RegistrationSource } from '../../models/registration/registration-source.enum';
import { RegistriaRequestCustomerDetails } from '../../models/registria/registria-request-customer-details.interface';

export const mockRegistriaRequestCustomerDetails: RegistriaRequestCustomerDetails =
  {
    address: {
      address1: '123 Main St',
      address2: 'Apt 4B',
      zip: '80202',
      city: 'Denver',
      state: 'CO',
      country: 'USA',
    },
    locale: 'en-US',
    email: 'johnscott@yahoo.com',
    first_name: 'John',
    last_name: 'Scott',
    phone: '+15555555555',
    token: undefined,
    source: RegistrationSource.PR,
  };
